var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfilePlaceholder = function SvgProfilePlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#123A47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.663 41.345c-3.305-1.251-5.499-2.054-5.499-2.054l-2.61 7.059-2.518-4.001s1.158-.37 1.158-1.22v-1.035s.124-1.36-1.683-1.36h-.356c-1.791 0-1.683 1.36-1.683 1.36v1.035c0 .834 1.158 1.22 1.158 1.22l-2.502 4-2.61-7.058s-2.194.803-5.5 2.054c-3.29 1.236-3.012 2.95-3.012 2.95v4.295c0 2.348 2.147 2.147 2.147 2.147h24.376s2.147.2 2.147-2.147v-4.295s.278-1.714-3.013-2.95zM28.038 30.702c.433 4.757 5.7 6.735 5.7 6.735.912.154 1.19-.031 1.499-.124 5.113-2.363 5.422-6.07 5.468-6.642 2.008 0 2.21-2.086 2.21-3.46 0-1.375-.897-1.329-1.422-1.329.386-1.684.185-2.518.185-2.518C40.535 17.062 35.098 17 33.847 17c-1.252 0-1.53.556-1.622 1.267-6.287.123-5.082 5.746-5.082 7.507-1.684.185-1.329 1.93-1.066 3.26.231 1.343 1.127 1.637 1.961 1.668z",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfilePlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-placeholder.4bc9eb5e.svg";
export { ForwardRef as ReactComponent };